import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=e328a4d6&"
import script from "./ColorPicker.vue?vue&type=script&lang=js&"
export * from "./ColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e328a4d6')) {
      api.createRecord('e328a4d6', component.options)
    } else {
      api.reload('e328a4d6', component.options)
    }
    module.hot.accept("./ColorPicker.vue?vue&type=template&id=e328a4d6&", function () {
      api.rerender('e328a4d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/field-template/helpers/ColorPicker.vue"
export default component.exports